import React from 'react'

function Privacy() {
  return (
    <div className="min-w-[280px] flex flex-col items-center px-6 pb-24 pt-36 text-muted">
      <div className="w-full max-w-3xl leading-relaxed [&_h3]:mt-10 [&_h3]:text-ink [&_strong]:text-ink">
      <h2 className="font-display font-bold text-3xl lg:text-5xl text-center mb-10 text-ink">Privacy Policy</h2>

      <p className="mb-6"><strong>Effective Date:</strong> 17-05-2025</p>

      <p className="mb-6">
        Lotez Technologies (OPC) Private Limited ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <a href="https://lotez.in" className="text-brand underline" target="_blank" rel="noopener noreferrer">https://lotez.in</a>, or use our services.
      </p>

      <h3 className="text-2xl font-semibold mb-2">1. Information We Collect</h3>
      <p className="mb-2">We may collect personal information such as:</p>
      <ul className="list-disc ml-6 mb-6 space-y-1">
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>IP address</li>
        <li>Any other data you provide directly</li>
      </ul>

      <h3 className="text-2xl font-semibold mb-2">2. How We Use Your Information</h3>
      <p className="mb-2">We use your information to:</p>
      <ul className="list-disc ml-6 mb-6 space-y-1">
        <li>Provide and manage our services</li>
        <li>Communicate with you</li>
        <li>Improve our website and offerings</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h3 className="text-2xl font-semibold mb-2">3. Sharing Your Information</h3>
      <p className="mb-6">
        We do not sell or rent your personal information. We may share it with:
      </p>
      <ul className="list-disc ml-6 mb-6 space-y-1">
        <li>Service providers acting on our behalf</li>
        <li>Legal authorities if required by law</li>
      </ul>

      <h3 className="text-2xl font-semibold mb-2">4. Your Rights</h3>
      <p className="mb-6">
        You have the right to access, correct, or delete your personal information. To exercise these rights, contact us at 
        <a href="mailto:hello@lotez.in"> hello@lotez.in</a>.
      </p>

      <h3 className="text-2xl font-semibold mb-2">5. Cookies</h3>
      <p className="mb-6">
        We may use cookies and similar tracking technologies. You can manage your cookie preferences through your browser settings.
      </p>

      <h3 className="text-2xl font-semibold mb-2">6. Third-Party Links</h3>
      <p className="mb-6">
        Our website may contain links to third-party sites. We are not responsible for their privacy practices.
      </p>

      <h3 className="text-2xl font-semibold mb-2">7. Contact Us</h3>
      <p className="mb-2">If you have any questions, contact us at:</p>
      <ul className=" mb-6">
        <li><strong>Email:</strong><a href="mailto:hello@lotez.in"> hello@lotez.in</a></li>
        <li><strong>Phone:</strong> +91 6303541414</li>
        <li><strong>Address:</strong> Hyderabad, Telangana, India</li>
      </ul>
    </div>
    </div>
  );
}


export default Privacy
